import chunk from "lodash-es/chunk";

type Node = {
  id?: string;
  type?: string;
};
type Edge = {
  id?: string;
  source?: string;
  target?: string;
};

const findArrayIndex = (arr: any[], item: any) => {
  const r: number[] = [];
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === item) {
      r.push(i);
    }
  }
  return r;
};

export const findRing = (data: {
  nodes?: Array<Node>;
  edges?: Array<Edge>;
}) => {
  const nodes = data.nodes || [];
  const edges = data.edges || [];
  const nodePath: Node[] = [];
  const edgePath: Edge[] = [];

  const result: Array<{
    nodes: Node[];
    edges: Edge[];
  }> = [];

  const o = nodes[0];
  nodePath.push(o);

  let c = o;
  const cEdges = edges.filter((v) => v.source === c.id);
  const nextNAndE = cEdges.map((v) => {
    return {
      node: nodes.find((n) => n.id === v.target),
      edge: v,
    };
  });

  const helper = (
    nextNAndE: Array<{
      node?: Node;
      edge: Edge;
    }>,
  ) => {
    for (let i = 0; i < nextNAndE.length; i++) {
      const { node, edge } = nextNAndE[i];
      if (node) {
        const si = findArrayIndex(nodePath, node);
        if (si.length > 0) {
          si.forEach((i) => {
            result.push({
              nodes: [...nodePath.slice(i), node],
              edges: [...edgePath.slice(i), edge],
            });
          });
        } else {
          c = node;
          nodePath.push(c);
          edgePath.push(edge);
          const cEdges = edges.filter((v) => v.source === c.id);
          const newNextNAndE = cEdges.map((v) => {
            return {
              node: nodes.find((n) => n.id === v.target),
              edge: v,
            };
          });

          helper(newNextNAndE);
          nodePath.pop();
          edgePath.pop();
        }
      }
    }
  };
  helper(nextNAndE);
  return result;
};

export const formatXGraphLabel = (label: string) => {
  const context = document.createElement("canvas").getContext("2d");
  let line = "";
  const lines: string[] = [];
  const maxLines = 3; // 最大行数
  const maxWidth = 120; // 每行最大宽度

  if (context) {
    for (let i = 0; i < label.length; i++) {
      const testLine = line + label[i];
      const metrics = context.measureText(testLine);
      const testWidth = metrics.width;

      if (testWidth > maxWidth && line.length > 0) {
        lines.push(line);
        line = label[i];

        // 如果已经达到最大行数，则添加省略号并退出循环
        if (lines.length === maxLines) {
          lines[maxLines - 1] = lines[maxLines - 1].slice(0, -3) + "...";
          break;
        }
      } else {
        line = testLine;
      }
    }

    // 如果还有剩余的行并且没有达到最大行数，则添加最后一行
    if (line && lines.length < maxLines) {
      lines.push(line);
    }

    return lines.join("\n");
  }

  // 如果 context 不可用，使用备用方法
  return chunk(label.split(""), 6)
    .map((v, index) => {
      if (index === maxLines - 1 && v.length === 6) {
        return v.slice(0, 3).join("") + "...";
      }
      return v.join("");
    })
    .slice(0, maxLines)
    .join("\n");
};
